/**
 * Display-name helper for reps/users in the UI.
 *
 * Prefers `first_name last_name`, then `username`, then the local part of
 * `email`, then the raw email. Accepts both snake_case (DB-shaped) and
 * camelCase (JWT-shaped) inputs so it can be used with `/auth/me` user
 * objects, rep list rows, and presence entries alike.
 */

export interface NameParts {
  first_name?: string | null;
  last_name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  email?: string | null;
}

export function formatRepName(u: NameParts | null | undefined): string {
  if (!u) return '';
  const first = u.first_name ?? u.firstName ?? '';
  const last = u.last_name ?? u.lastName ?? '';
  const full = [first, last]
    .filter((p) => p && p.trim())
    .join(' ')
    .trim();
  if (full) return full;
  if (u.username && u.username.trim()) return u.username.trim();
  const email = u.email ?? '';
  if (email) {
    const local = email.split('@')[0];
    return local || email;
  }
  return '';
}
